import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  Typography,
  DialogActions,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material';

function doIdFilter(arr, idToRemove) {
  return arr.filter(x => x !== idToRemove);
}

function AcceptRejectDialog({
  isOpen,
  handleClose,
  lineItem,
  mode,
  handleRejectEncounterLineItem,
  handleAcceptEncounterLineItem,
  reasonOptions
}) {
  const [selectedReasonOptionIds, setSelectedReasonOptionIds] = useState([]);

  if (lineItem === null) return null;

  const filteredReasonOptions = reasonOptions
    .filter(x => {
      const isAcceptMode = mode.toLowerCase() === 'accept';
      if (isAcceptMode === true && x.reasonType.toLowerCase() === 'approve') {
        return true;
      } else if (isAcceptMode === false && x.reasonType.toLowerCase() === 'remove') {
        return true;
      }
      return false;
    });

  if (filteredReasonOptions.length < 1) {
    // TODO polish this
    return alert('ERROR: No reason options configured');
  }

  return (
    <Dialog
      onClose={() => {
        handleClose();
      }}
      open={isOpen}
      fullWidth
      maxWidth="lg"
      disableEscapeKeyDown
    >
      <Box sx={{ padding: '20px' }}>
        <Typography variant="h6">{mode.toUpperCase()} - Select Reason Options</Typography>

        <Box>
          <FormGroup>
          {
            filteredReasonOptions.map(x => {
              return (
                <FormControlLabel
                  key={x.reasonOptionId}
                  control={
                    <Checkbox
                      size="small"
                      checked={selectedReasonOptionIds.indexOf(x.reasonOptionId) !== -1}
                      onChange={() => {
                        const isAlreadySelected = selectedReasonOptionIds.indexOf(x.reasonOptionId) !== -1;

                        if (isAlreadySelected === false) {
                          setSelectedReasonOptionIds(prev => [...prev, x.reasonOptionId]);
                        } else {
                          const idToRemove = x.reasonOptionId;
                          setSelectedReasonOptionIds(prev => {
                            return doIdFilter(prev, idToRemove);
                          });
                        }
                      }}
                    />
                  }
                  label={x.displayName}
                />
              );
            })
          }
          </FormGroup>
        </Box>
      </Box>
      <DialogActions>
        <Button
          onClick={() => {
            const handler = mode === 'accept'
              ? handleAcceptEncounterLineItem
              : handleRejectEncounterLineItem;

            handler(lineItem.encounterLineItemId, lineItem.encounterId, selectedReasonOptionIds)
              .then(handleClose());
          }}
          disabled={selectedReasonOptionIds.length < 1}
        >
          Ok
        </Button>
        <Button onClick={() => {
          // setRejectionReason('');
          handleClose();
        }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AcceptRejectDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired
};

export { AcceptRejectDialog };
